var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            top: "50px",
            title: "片源适配配置",
            visible: _vm.dialogVisible,
            width: "60%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c("span", { staticClass: "tip-text" }, [
                  _vm._v(
                    "\n          说明：c=1 按域名匹配（每日定时自动剔除失效域名），c=2 按路径匹配；每条规则包含 c、u、o 字段，o 子项包含 f、t 及配置项。\n        "
                  ),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: { click: _vm.fillTemplate },
                      },
                      [_vm._v("填入示例模板")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary", plain: "" },
                        on: { click: _vm.formatRawJson },
                      },
                      [_vm._v("格式化 JSON")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "编辑原始配置（raw）", name: "raw" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 14,
                          placeholder:
                            '请输入片源配置 JSON 数组，例如：[{"c":1,"u":["scgchc.com"],"o":[{"f":1,"t":1,"user_agent":"Mozilla/5.0"}]}]',
                        },
                        model: {
                          value: _vm.rawConfigStr,
                          callback: function ($$v) {
                            _vm.rawConfigStr = $$v
                          },
                          expression: "rawConfigStr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: "当前线上生效配置（active，只读预览）",
                        name: "active",
                      },
                    },
                    [
                      _c("div", { staticClass: "active-tip" }, [
                        _vm._v(
                          "\n            展示经每日定时任务剔除失效域名后实际下发的配置，可与「原始配置」对比哪些失效域名已被自动清理。\n          "
                        ),
                      ]),
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 14,
                          readonly: "",
                          placeholder: "暂无生效配置",
                        },
                        model: {
                          value: _vm.activeConfigStr,
                          callback: function ($$v) {
                            _vm.activeConfigStr = $$v
                          },
                          expression: "activeConfigStr",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("input", false)
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }